__turbopack_context__.v({
  "act": "property-list-module__gshzva__act",
  "label": "property-list-module__gshzva__label",
  "list": "property-list-module__gshzva__list",
  "value": "property-list-module__gshzva__value",
});
